import React, { useContext, useEffect, useState } from "react";
import { SessionContext, initialState } from "../../Session";
import { navigate } from "gatsby";
import HeaderSection from "../components/HeaderSection";
import ApplicationLayout from "../../../components/ApplicationLayout";
import Shimmer from "../../../components/smallShimmer";
import LoginComponent from '../components/LoginComponent';

function MainSection() {
  const { session } = useContext(SessionContext) || {
    session: initialState
  };

  // Check to see if authenticated
  useEffect(
    () => {      
      if (session.staff.authenticated) {
        navigate('/form_list')
      }
    },
    [session.staff.authenticated]
  );

  return (
    <section className="section has-background-light">
      <div className="hero-body">
        <div className="container has-text-centered">
          <div className="column is-4 is-offset-4">
            <h3 className="title">Staff Login</h3>
            
            <div className="box">
              <div className="field">
                <div className="control">
                  <label htmlFor="member_phone_number">Enter Password</label>
                  <br />
                  <br />
                  <LoginComponent />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function AccessPage() {
  return (
      <ApplicationLayout>
        <HeaderSection />
        <MainSection />
      </ApplicationLayout>
  );
}
export default AccessPage;
